/*
 * 根据URL的层次或者哈希「递进地」划分URL
 * 示例：
 * https://A.B/C#D
 * -> ['https://A.B', 'https://A.B/C', 'https://A.B/C#D']
 */
export function parseUrlBySlash(url: string): string[] {
  const u: URL = new URL(url);
  const subPath: string[] = u.pathname.split('/');
  let prefix = `${u.protocol}//${u.host}`;
  const res = [prefix];
  for (const p of subPath) {
    if (p.length === 0) {
      continue;
    }
    if (!prefix.endsWith('/')) {
      prefix += '/';
    }
    prefix += p;
    res.push(prefix);
  }
  if (u.hash.length) {
    res.push(prefix + u.hash);
  }
  return res;
}

/*
 * 根据层次或哈希分割url
 * 第一级保留为协议和域名的组合，会处理哈希但不会处理query
 *
 * 示例：
 * https://x/A/B#C?D
 * -> ['https://x', 'A', 'B', 'C', 'D']
 */
export function splitUrlBySlashOrHash(url: string): string[] {
  try {
    const u: URL = new URL(url);
    const res: string[] = u.pathname.split('/');
    res[0] = `${u.protocol}//${u.host}`;
    if (u.hash.length) {
      res.push(u.hash.replace('#', ''));
    }
    return res;
  } catch (_) {
    return [];
  }
}
